<template>
  <!-- 主要内容始终渲染，在动画下方 -->
  <el-config-provider :key="localeKey" :locale="elementLocale">
    <div class="main-content">
      <router-view :key="localeKey" />
    </div>
  </el-config-provider>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import i18n from '@/i18n'
import { elementLocales } from '@/i18n'

const elementLocale = computed(() => {
  const lang = i18n.global.locale.value as 'zh' | 'en'
  return elementLocales[lang] || elementLocales.zh
})

const localeKey = computed(() => `app-locale-${i18n.global.locale.value}`)
</script>
<style></style>
